import config from "@/config";
import http from "@/utils/request";
export default {
  // get请求
  getTest: {
    url: `${config.API_URL}/api/front/product/leaderboard`,
    name: "get请求测试",
    get: async function () {
      return await http.get(this.url);
    },
  },
  // post 请求
  postTest: {
    url: `${config.API_URL}/api/post/xxx`,
    name: "post请求测试",
    post: async function (data) {
      return await http.post(this.url, data);
    },
  },
  // 获取首页数据
  getHomeData: {
    url: `${config.API_URL}/api/front/home/list`,
    name: "首页数据",
    get: async function () {
      return await http.get(this.url);
    },
  },
  // 政策解读
  getZcjdData: {
    url: `${config.API_URL}/api/front/article/policyList`,
    name: "政策解读",
    get: async function (data) {
      return await http.get(
        `${this.url}?page=${data.page}&limit=${data.limit}`
      );
    },
  },
  // 行业动态
  getHydtData: {
    url: `${config.API_URL}/api/front/article/cultureList`,
    name: "行业动态",
    get: async function (data) {
      return await http.get(
        `${this.url}?page=${data.page}&limit=${data.limit}`
      );
    },
  },
  // 资讯详情
  getZixuDetailsData: {
    url: `${config.API_URL}/api/front/article/info`,
    name: "资讯详情",
    get: async function (id) {
      return await http.get(`${this.url}?id=${id}`);
    },
  },
  // 通知公告
  getNoticeListData: {
    url: `${config.API_URL}/api/front/article/noticeList`,
    name: "通知公告",
    get: async function (data) {
      return await http.get(
        `${this.url}?page=${data.page}&limit=${data.limit}`
      );
    },
  },
  // 产业生态圈
  ecosphereList: {
    url: `${config.API_URL}/api/front/ecosphere/list`,
    name: "产业生态圈",
    get: async function (id) {
      return await http.get(`${this.url}`);
    },
  },
  // 荣誉榜
  getTalentHonor: {
    url: `${config.API_URL}/api/front/talentHonor/list`,
    name: "荣誉榜",
    get: async function (data) {
      return await http.get(
        `${this.url}?page=${data.pageNum}&limit=${data.pageSize}`
      );
    },
  },
  // 员工风采
  getOurDemeanour: {
    url: `${config.API_URL}/api/front/gw/ourDemeanour/list`,
    name: "员工风采",
    get: async function (data) {
      return await http.get(
        `${this.url}?page=${data.page}&limit=${data.limit}`
      );
    },
  },
  // 创始团队
  getTeamCoreData: {
    url: `${config.API_URL}/api/front/gw/teamCore/list`,
    name: "创始团队",
    get: async function (data) {
      return await http.get(
        `${this.url}?page=${data.page}&limit=${data.limit}`
      );
    },
  },

  // 企业信息
  getCompanyInformation: {
    url: `${config.API_URL}/api/front/gw/companyInformation/list`,
    name: "企业信息",
    get: async function () {
      return await http.get(`${this.url}`);
    },
  },

  // 关于集团
  getAboutGroup: {
    url: `${config.API_URL}/api/front/gw/aboutGroup/list`,
    name: "关于集团",
    get: async function () {
      return await http.get(`${this.url}`);
    },
  },

  // 社会招聘
  getShzpData: {
    url: `${config.API_URL}/api/front/gw/recruit/shzp`,
    name: "社会招聘",
    get: async function (data) {
      return await http.get(
        `${this.url}?pageNum=${data.pageNum}&pageSize=${data.pageSize}`
      );
    },
  },
  // 校园招聘
  getXyzpData: {
    url: `${config.API_URL}/api/front/gw/recruit/xyzp`,
    name: "校园招聘",
    get: async function (data) {
      return await http.get(
        `${this.url}?pageNum=${data.pageNum}&pageSize=${data.pageSize}`
      );
    },
  },
  // 实习生招聘
  getSxsData: {
    url: `${config.API_URL}/api/front/gw/recruit/sxszp`,
    name: "实习生招聘",
    get: async function (data) {
      return await http.get(
        `${this.url}?pageNum=${data.pageNum}&pageSize=${data.pageSize}`
      );
    },
  },
  // 培训政策
  getTrainingZcData: {
    url: `${config.API_URL}/api/front/article/policyTrainingList`,
    name: "培训政策",
    get: async function (data) {
      return await http.get(
        `${this.url}?page=${data.page}&limit=${data.limit}`
      );
    },
  },
  // 培训体系
  getTrainingTxData: {
    url: `${config.API_URL}/api/front/article/systemTrainingList`,
    name: "培训体系",
    get: async function (data) {
      return await http.get(
        `${this.url}?page=${data.page}&limit=${data.limit}`
      );
    },
  },
  // 培训动态
  getTrainingDtData: {
    url: `${config.API_URL}/api/front/article/dynamicsTrainingList`,
    name: "培训动态",
    get: async function (data) {
      return await http.get(
        `${this.url}?page=${data.page}&limit=${data.limit}`
      );
    },
  },

  // 培训详情
  getTrainingDetailsData: {
    url: `${config.API_URL}/api/front/article/info`,
    name: "培训详情",
    get: async function (id) {
      return await http.get(`${this.url}${id}`);
    },
  },

  // 联系我们
  getBackgroundImage: {
    url: `${config.API_URL}/api/front/gw/backgroundImage/list`,
    name: "联系我们",
    get: async function (addess) {
      return await http.get(`${this.url}?addess=${addess}`);
    },
  },

    // 获取模块顶部信息
    getOfficialWebsiteNavigation: {
      url: `${config.API_URL}/api/front/officialWebsiteNavigation/list`,
      name: "模块",
      get: async function (data) {
        return await http.get(`${this.url}?positionIdentifier=${data}`);
      },
    },

    // 获取模块列表内容数据
    getNavigationContentList: {
      url: `${config.API_URL}/api/front/navigationContent/list`,
      name: "模块列表",
      get: async function (url,data) {
        return await http.get(`${this.url}?positionIdentifier=${url}`,data);
      },
    },
};


